<template>
    <div style="padding: 20px 0px 0px 20px;">

        <el-form style="display: flex;flex-wrap: wrap;">
              <!-- <el-form-item label="成单状态:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择成单状态" v-model="input1" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.name"></el-option>
                  </el-select>
              </el-form-item> -->

                <el-form-item label="订单号" style=" display: flex;">
                  <el-input v-model="customerId" placeholder="请输入订单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="城市" style=" display: flex;margin-left: 20px;">
                  <el-select v-model="regionName" clearable filterable placeholder="请选择城市">
                    <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学生姓名" style=" display: flex;margin-left: 20px;">
                  <el-input v-model="searchStudent" placeholder="请输入学生姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="年级" style=" display: flex;margin-left: 20px;">
                  <el-cascader clearable v-model="grade" :options="gradeListoptions" :props="gradeListprops"></el-cascader>
                </el-form-item>
                <el-form-item label="客资类型" style=" display: flex;">
                  <el-select clearable filterable   id="teacher" class="select" v-model="orderStatuss" placeholder="请选择客资类型">
                    <el-option v-for="item in orderTypes11" :key="item.value" :value="item.value" :label="item.label">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="费用类型" style=" display: flex;margin-left: 20px;">
                  <el-select clearable filterable   id="teacher" class="select" v-model="orderStatusss" placeholder="请选择费用类型">
                    <el-option v-for="item in orderTypes111" :key="item.value" :value="item.value" :label="item.label">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="期数" style=" display: flex;margin-left: 20px;">
                  <el-input v-model="customerIds" placeholder="请输入期数" clearable></el-input>
                </el-form-item>
                <el-form-item label="销售" style=" display: flex;margin-left: 20px;">
                  <el-select v-model="inputAcount1" filterable  clearable  placeholder="请选择销售">
                    <el-option v-for="item in optionsList1" :key="item.id" :label="item.label" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="审批状态" style=" display: flex;">
                  <el-select v-model="inputAcount2" filterable  clearable  placeholder="请选择审批状态">
                    <el-option v-for="item in optionsList111" :key="item.id" :label="item.label" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="提交人" style=" display: flex;margin-left: 20px;">
                  <el-select v-model="inputAcount" filterable  clearable  placeholder="请选择提交人">
                    <el-option v-for="item in optionsList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="完成时间" style="margin-right: 1.5rem; display: flex;margin-left: 20px;">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="createTimess" type="daterange" clearable range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item> 
                <el-form-item label="创建时间" style="margin-right: 1.5rem; display: flex;">
                  <el-date-picker value-format="yyyy-MM-dd" v-model="createTimesss" type="daterange" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </el-form-item>


              <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>

          </el-form>


          <el-table v-loading="tableLoading"  element-loading-text="加载中..."  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
              
            <el-table-column prop="customerId" label="订单号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="regionName" label="城市" width="100"></el-table-column>
            <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip></el-table-column>

            <el-table-column prop="gradeName" label="年级" show-overflow-tooltip width="200"></el-table-column>


              <!-- <el-table-column prop="orderStatus" label="成单状态" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div v-if="scope.row.orderStatus === 1">已成单</div>
                      <div v-if="scope.row.orderStatus === 2">未成单</div>
                </template>
              </el-table-column> -->

              <el-table-column prop="customerType" label="客资类型" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div v-if="scope.row.customerType === 1">定金客资</div>
                      <div v-if="scope.row.customerType === 2">成单客资</div>
                      <div v-if="scope.row.customerType === 3">退费客资</div>
                </template>
              </el-table-column>


              <el-table-column prop="costType" label="费用类型" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div v-if="scope.row.costType === 1">全款</div>
                      <div v-if="scope.row.costType === 2">分期</div>
                      <div v-if="scope.row.costType === 3">续费</div>
                      <div v-if="scope.row.costType === 4">退费</div>
                </template>
              </el-table-column>

              <el-table-column prop="periodsNumber" label="期数" show-overflow-tooltip></el-table-column>
              <el-table-column prop="saleName" label="销售" show-overflow-tooltip></el-table-column>


              <el-table-column prop="auditStatus" label="审批状态" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 0">待审批</div>
                      <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 1">驳回</div>
                      <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);" v-if="scope.row.auditStatus === 2">已完成</div>
                </template>
              </el-table-column>


              <!-- <el-table-column prop="customerTeacherid" label="老师" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{
                    scope.row.customerTeacherid === 1
                    ? "小单老师"
                    : scope.row.customerTeacherid === 2
                      ? "大单老师"
                      : scope.row.customerTeacherid === 3
                        ? "刘老师"
                        : scope.row.customerTeacherid === 4
                          ? "杨老师"
                          : ""
                  }}</span>
                </template>
              </el-table-column> -->


              <el-table-column prop="commitName" label="提交人" show-overflow-tooltip width="110"></el-table-column>
              
              <!-- <el-table-column prop="uploadingPicture" label="付款截图" show-overflow-tooltip>
                <template slot-scope="scope">

                      <viewer>
                        <img  :src="scope.row.uploadingPicture" style="width:100px;" />
                      </viewer>
                </template>
              </el-table-column> -->

              <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip  width="200"></el-table-column>
              <el-table-column prop="accomplishTime" label="完成时间" show-overflow-tooltip  width="200"></el-table-column>

              <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;">


                        <!-- :style="{  color: scope.row.auditStatus === 2 || scope.row.auditStatus === 1 ? 'rgb(176 180 182)' : '#00aaff'  }"
                                :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1" -->
                          <el-button type="text"
                                :style="{  color: scope.row.auditStatus === 2 || scope.row.auditStatus === 1 ? 'rgb(176 180 182)' : '#00aaff'  }"
                                :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1"
                                @click="handleClickView('审批', scope.row)" >审批
                          </el-button>

                          <!-- :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1" -->

                          <!-- <el-button type="text"
                               :style="{ color: scope.row.auditStatus === 2 || scope.row.auditStatus === 1 ? 'rgb(176 180 182)' : '#00aaff' }"
                               :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1"
                               @click="handleClickView('编辑', scope.row)">编辑
                          </el-button> -->

                          <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>

                      </div>
                  </template>
              </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>


          <orderOrderDetailComponents ref="OrderDetail" v-if="orderDetailComponentsShow" :uploadingPicture="uploadingPicture" :orderFormComponentsType="orderFormComponentsType" :orderFormComponentsID="orderFormComponentsID" @handleEventColes="handleEventColes" :typeCustomerFunding="typeCustomerFunding" :isUrView="isUrView"></orderOrderDetailComponents>

          <orderOrderUpdateComponents ref="OrderUpdate" v-if="orderUpdateComponentsShow" :uploadingPicture="uploadingPicture" :orderFormComponentsType="orderFormComponentsType" :orderFormComponentsID="orderFormComponentsID" @handleEventCole="handleEventCole"></orderOrderUpdateComponents>

          <newModesCustomerFundingDetail v-if="isnewModesCustomerFundingDetail" ref="newModesCustomerFundingDetail" @newModesCustomerFundingDetailEvent="newModesCustomerFundingDetailEvent" :typeCustomerFunding="typeCustomerFunding" :isUrView="isUrView"></newModesCustomerFundingDetail>


          <!-- <viewer :images="urlshowImgiList">
            <img  style="position: absolute; margin-top: 15px; width: 30px; height: 30px;" v-for="(src, index) in urlshowImgiList" :src="src"  :key="index"  />
          </viewer> -->


    </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import orderOrderDetailComponents from './OrderDetail.vue'
import orderOrderUpdateComponents from './OrderUpdate.vue'
import { handleStudent, handleTeacher } from "../utils/publicInterface";
import { getStudentsType } from "@/api/fiveClassApi"

import newModesCustomerFundingDetail from "./newModesCustomerFundingDetail.vue";
export default {
    components:{
        orderOrderDetailComponents,
        orderOrderUpdateComponents,
        newModesCustomerFundingDetail,
    },
    data() {
       return{

            props: {
              label: "categoryName",
              children: "children",
              value: "id"
            },


            input222:'',
            input2222:'',

            createTimeStart:'',
            createTimeEnd:'',
            completeTimeStart:'',
            completeTimeEnd:'',

            uploadingPicture:'',
            typeCustomerFunding:'',
            isUrView:'',

            orderDetailComponentsShow: false,
            orderUpdateComponentsShow: false,
            orderFormComponentsID:'',
            orderFormComponentsType:'',


            optionList1:[{id:1,name:'已成单'},{id:2,name:'未成单'}],
            optionList2:[],
            optionList3:[],
            optionList4:[{id:0,name:'待审批'},{id:1,name:'驳回'},{id:2,name:'已完成'}],

            optionsList111:[
              {
                id:0,
                label:'待审批'
              },
              {
                id:2,
                label:'已完成'
              },
              {
                id:1,
                label:'驳回'
              },
            ],

            input1:'',
            input2:'',
            input3:'',
            input4:'',

            orderTypes111:[
              {
                value: 1,
                label: '全款'
              },
              {
                value: 2,
                label: '分期'
              },
              {
                value: 3,
                label: '续费'
              },
              {
                value: 4,
                label: '退费'
              },
            ],

            customerId: '',
            regionName: '',
            searchStudent: '',
            grade: [],
            orderStatuss: '',
            orderStatusss: '',
            customerIds: '',
            inputAcount1: '',
            inputAcount2: '',
            inputAcount: '',
            createTimess: [],
            createTimesss: [],


            dataList:[],

            pageNum: 1,
            pageSize: 10,
            total: 0,

            customerAccountName:'',

            input5:'',
            optionsListt:[
                {dictValue:"北京", dictType:1 },
                {dictValue:"深圳", dictType:2 },
            ],
            optionsListtt:[
                {dictValue:"成单客资", dictType:2 },
                {dictValue:"退费客资", dictType:3 },
            ],


            customerType1:'',
            optionsListttt:[
                {dictValue:"全款", dictType:1 },
                {dictValue:"分期", dictType:2 },
                {dictValue:"续费", dictType:3 },
                {dictValue:"退费", dictType:4 },
            ],


            customerType:'',

            orderTypes11:[
              {
                value: 1,
                label: '成单客资'
              },
              {
                value: 2,
                label: '退费客资'
              },
            ],
            isnewModesCustomerFundingDetail: true,


            tableLoading: false,

            showImgis: false,
            urlshowImgis:'',
            urlshowImgiList:[],

            gradeListprops:{
              label: "gradeName",
              children: "children",
              value: "id"
            },
            gradeListoptions:[],
            gradeList:[],


            optionsList:[],
            optionsList1:[],

       }
    },

    mounted(){
        this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj'))

        axios.get(`${ apiBaseUrl }/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionList2 = res.data.data  })
        getStudentsType(2).then(res => {
            let data = res.data
            getStudentsType(1).then(_res => {
                 this.optionList3 = [...data,..._res.data]
            })
        })

        this.getApiList()
        
        axios.get(`${ apiBaseUrl }/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionsList = res.data.data })


        axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
        { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
        }).then((res)=>{ this.optionsListt = res.data.data})


        axios.get(`${apiBaseUrl}/grade/getGrade`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  } }).then(res => {
          if (res.data.data.length > 0) {
            this.gradeListoptions = res.data.data;
          } else {
            this.$message({ message: "获取年级列表失败",  type: "error"  });
          }
        }).catch(error => {
          console.log(error);
        });
    },


    methods:{

        newModesCustomerFundingDetailEvent(){
          this.isnewModesCustomerFundingDetail = false
          this.getApiList()
        },

        getApiList(){
            let data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                customerId: this.customerId,
                regionName: this.regionName,
                studentName: this.searchStudent,
                grade: this.grade.length > 0 ? JSON.stringify(this.grade)  : '',
                saleId: this.inputAcount1,
                costType: this.orderStatusss,
                periodsNumber: this.customerIds,
                auditStatus: this.inputAcount2,
                createTimeStart: this.createTimesss.length > 0 ? this.createTimesss[0] + ' 00:00:00' :  null,
                createTimeEnd: this.createTimesss.length > 0 ? this.createTimesss[1] + ' 23:59:59' :  null,
                accomplishTimeStart: this.createTimess.length > 0 ? this.createTimess[0] + ' 00:00:00' :  null,
                accomplishTimeEnd: this.createTimess.length > 0 ? this.createTimess[1] + ' 23:59:59' :  null

            }

            // orderCustomerAudit/find

            this.tableLoading = true

            axios.post(`${apiBaseUrl}/customerInformationCollectionAudit/find`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                  this.tableLoading = false
                  if(res.data.code === 200){

                    let data = res.data.data
                    this.dataList = data.records
                    this.pageNum = data.current ? data.current : 0
                    this.pageSize = data.size ? data.size : 10
                    this.total = data.total ? data.total : 0

                    // this.$message({ message: res.data.message, type: "success" })
                  }else{
                    this.dataList = []
                  }
            }).catch((err)=>{
                this.tableLoading = false
                this.$message({ message: err , type: "error" })
            })
        },


        handleImg(url){
          if(url){
            this.showImgis = true
            this.urlshowImgis = url
            this.urlshowImgiList[0] = url
          }
        },

        searchBtns(){
            this.getApiList()
        },

        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''

            this.createTimeStart = ''
            this.createTimeEnd = ''
            this.completeTimeStart = ''
            this.completeTimeEnd = ''

            this.customerType = ''


            this.input222 = ''
            this.gradeList = []
            this.customerType1 = ''
            this.input2222 = ''
            this.customerAccountName = ''


            this.customerId = ''
            this.regionName = ''
            this.searchStudent = ''
            this.grade = []
            this.orderStatuss = ''
            this.orderStatusss = ''
            this.customerIds = ''
            this.inputAcount1 = ''
            this.inputAcount2 = ''
            this.inputAcount = ''
            this.createTimess = []
            this.createTimesss = []

                

            this.getApiList()
        },

        handleSizeChange(e){
            this.pagepageSizeNum = e
            this.getApiList()
        },

        handleCurrentChange(e){
            this.pageNum = e
            this.getApiList()
        },

        handleClickView(type,itme){
            this.orderFormComponentsType = type
            this.orderFormComponentsID = itme.customerId

            this.uploadingPicture = itme.uploadingPicture ?  itme.uploadingPicture : ''

            this.typeCustomerFunding = itme.customerType === 2  ? '成单' : itme.customerType === 3  ? '退费' : ''
            this.isUrView = itme.customerType === 2  ? '/orderCustomer/updateOrder' : itme.customerType === 3  ? '/orderCustomer/updateReturnPremium' : '/orderCustomer/updatePayment'

            if(this.orderFormComponentsType === '编辑'){
                // this.orderUpdateComponentsShow = true
                // this.$nextTick(() => {
                //     this.$refs.OrderUpdate.init(itme.id)
                // })


                this.typeCustomerFunding = itme.customerType === 2  ? '成单' : itme.customerType === 3  ? '退费' : '定金'
                this.isUrView = itme.customerType === 2  ? '/orderCustomer/updateOrder' : itme.customerType === 3  ? '/orderCustomer/updateReturnPremium' : '/orderCustomer/updatePayment'


                if(itme.customerType == 1){
                    this.orderUpdateComponentsShow = true
                    this.$nextTick(() => {
                        this.$refs.OrderUpdate.init(itme.id)
                    })
                }else{
                    this.isnewModesCustomerFundingDetail = true
                    this.$nextTick(() => {
                        this.$refs.newModesCustomerFundingDetail.init(itme.id,1)
                    })

                }

            }

            if(this.orderFormComponentsType === '审批' || this.orderFormComponentsType === '详情'){
                this.orderDetailComponentsShow = true
                this.$nextTick(() => {
                    this.$refs.OrderDetail.orderCustomerAudit(itme.id)
                })
            }
        },

        handleEventColes(event){
            this.orderDetailComponentsShow = event
            this.getApiList()
        },

        handleEventCole(event){
            this.orderUpdateComponentsShow = event
        },

    }

}
</script>


<style scoped lang="less">

    .no-click {
       pointer-events: none;
    }

    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }


</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/OrderAmountApproval.vue